import type { ApolloError } from "@apollo/client"
import { useToast } from "@mallardbay/lib-react-components"

import type { QuoteInterfaceFieldsFragment } from "~graphql/generated/graphql"
import { useDraftQuoteQuery } from "~graphql/generated/graphql"
import type { UseDraftQuoteArgs } from "~utils/quote-helpers"
import { useDraftQuoteParams } from "~utils/quote-helpers"

export default function useDraftQuote({
    pricingPackageId,
    dates,
    addOns,
    totalGuests,
    coupon,
    bookingInviteId,
    listingId,
}: UseDraftQuoteArgs) {
    const { showError } = useToast()

    const quoteParams = useDraftQuoteParams({
        pricingPackageId,
        dates,
        addOns,
        totalGuests,
        coupon,
        bookingInviteId,
        listingId,
    })

    const isParamsIncomplete = dates.length < 1 || !pricingPackageId

    const {
        data,
        loading: isLoading,
        error,
    } = useDraftQuoteQuery({
        variables: quoteParams,
        skip: isParamsIncomplete,
        fetchPolicy: "no-cache",
        onError: showError,
    })
    const draftQuote = data?.draftQuote ?? null
    const isTripValid = validateTrip({ error, draftQuote, isLoading, dates })

    return { draftQuote, isLoading, error, isTripValid }
}

function validateTrip({
    error,
    draftQuote,
    isLoading,
    dates,
}: {
    error?: ApolloError | null
    draftQuote?: QuoteInterfaceFieldsFragment | null
    isLoading: boolean
    dates: Date[]
}) {
    return !error && Boolean(draftQuote) && !isLoading && dates.length > 0
}
